export const DEFAULT_TIMEOUT_MS = 500;

export async function withTimeout(promise: Promise<unknown> | undefined, timeoutMs = DEFAULT_TIMEOUT_MS) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    await Promise.race([
      promise?.catch(() => {}) ?? Promise.resolve(),
      new Promise((resolve) => {
        timer = setTimeout(resolve, timeoutMs);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
